import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { waLink, WA_DEFAULT, WA_DISPLAY } from "@/lib/wa";
import { trackWhatsApp, trackPhone } from "@/lib/analytics";
import { spawnButterflies } from "@/components/site/Butterflies";

const NAV = [
  { to: "/", label: "Início" },
  { to: "/catalogo-insulfilm-rj", label: "Catálogo" },
  { to: "/servicos", label: "Serviços" },
  { to: "/orcamento", label: "Orçamento" },
  { to: "/duvidas-sobre-insulfilm", label: "Dúvidas" },
];

const onNavClick = (e) => spawnButterflies(e.clientX, e.clientY);

export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const waHref = waLink(WA_DEFAULT);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-navy/10 bg-white/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:h-20 md:px-10">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3" aria-label="Bella Film RJ — Início">
          <img src="/images/logo-sm.webp" srcSet="/images/logo-sm-160.webp 160w, /images/logo-sm.webp 400w" sizes="73px" alt="Bella Film RJ" className="h-9 w-auto md:h-11" width="73" height="44" />
        </Link>
        <nav className="hidden items-center gap-8 md:flex" aria-label="Menu principal">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase().replace("ç", "c").replace("í", "i").replace("ú", "u")}`}
              onClick={onNavClick}
              className={({ isActive }) =>
                `font-display text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-aqua" : "text-navy hover:text-aqua"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href={waHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-contato-whatsapp"
            onClick={(e) => { onNavClick(e); trackWhatsApp("header", "Menu Contato"); }}
            className="font-display text-sm font-medium tracking-wide text-navy transition-colors hover:text-aqua"
          >
            Contato
          </a>
          <a
            href={waHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta-orcamento"
            onClick={() => trackWhatsApp("header", "CTA Orçamento")}
            className="rounded-full bg-aqua px-6 py-2.5 font-display text-sm font-bold text-navy transition-all hover:-translate-y-0.5 hover:bg-aqua-dark hover:text-white hover:shadow-lg"
          >
            Solicitar orçamento
          </a>
        </nav>
        <button
          data-testid="mobile-menu-toggle"
          className="flex h-11 w-11 items-center justify-center rounded-full text-navy md:hidden"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Fechar menu" : "Abrir menu"}
          aria-expanded={open}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <nav className="border-t border-navy/10 bg-white px-5 pb-6 pt-2 md:hidden" aria-label="Menu móvel" data-testid="mobile-menu">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`mobile-nav-${item.label.toLowerCase().replace("ç", "c").replace("í", "i").replace("ú", "u")}`}
              onClick={(e) => { onNavClick(e); setOpen(false); }}
              className={({ isActive }) =>
                `block border-b border-navy/5 py-4 font-display text-lg font-medium ${isActive ? "text-aqua" : "text-navy"}`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href={waHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-nav-contato-whatsapp"
            onClick={(e) => { onNavClick(e); trackWhatsApp("mobile_menu", "Menu Contato"); setOpen(false); }}
            className="block border-b border-navy/5 py-4 font-display text-lg font-medium text-navy"
          >
            Contato (WhatsApp)
          </a>
          <a
            href="tel:+552120184446"
            data-testid="mobile-nav-telefone"
            onClick={trackPhone}
            className="block py-4 font-display text-lg font-medium text-navy"
          >
            Ligar: {WA_DISPLAY}
          </a>
          <a
            href={waHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-header-cta-orcamento"
            onClick={() => trackWhatsApp("mobile_menu", "CTA Orçamento")}
            className="mt-2 block rounded-full bg-aqua py-3.5 text-center font-display text-base font-bold text-white"
          >
            Solicitar orçamento
          </a>
        </nav>
      )}
    </header>
  );
}
